/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Customer_Name_Too_LongInputs */

const vi_customer_name_too_long = /** @type {(inputs: Customer_Name_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tên khách hàng tối đa ${i?.max} ký tự.`)
};

/**

* @param {Customer_Name_Too_LongInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_name_too_long = /** @type {((inputs: Customer_Name_Too_LongInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Name_Too_LongInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_name_too_long(inputs)
});